import { App } from "./system/App"
import FontFaceObserver from 'fontfaceobserver'
import './styles.css';
import { addSentry, debouncedResize, disableScrollIos, resize } from "./utils/helpers";


// initCode()
window.onload = async () => {
    try {
        addSentry()
        //disable smooth scroll in ios devices
        disableScrollIos()
        //insure uploading fonts before init the app
        const barlowFont = new FontFaceObserver('Barlow', { weight: 500 });
        const robotoFont = new FontFaceObserver('Roboto', { weight: 400 });
        await Promise.all([
            barlowFont.load(),
            robotoFont.load()
        ])
        await App.run()


    } catch (error) {
        console.error(error)
        await App.run()
    }



    //resizing
    const theCanvas = document.getElementById('canvas') as HTMLDivElement
    // Debounce the resize function and make the canvas container opacity to 0 until it finishes resizing
    window.addEventListener('resize', () => {
        theCanvas.style.opacity = '0'
        debouncedResize()
    });

    resize()


}



function initCode(){
    const container = document.querySelector(".loader-container") as HTMLElement;
    if(container) {
        container.style.scale = `${window.innerWidth < 410 ? ((window.innerWidth - 68)/372) : 1}`
        container!.style.opacity= "1"
    }
}
